import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const Filter = (props: IProps) => (
  <SvgIcon {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4H21V6.96837L15 12.4368V18.5L9 20V12.4368L3 6.96837V4ZM5 6.03163V6H19V6.03163L13 11.5V16.9384L11 17.4384V11.5L5 6.03163Z" />
  </SvgIcon>
);
